import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { IMeResponse, User } from './interfaces';

export const getCurrentUser = async (): Promise<User> => {
  const response: AxiosResponse<IMeResponse> = await apiClient.get('/me');

  return response.data.data;
};
